import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AbstractControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {AuthService} from "../../service/auth.service";
import {MatDialog} from "@angular/material/dialog";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['../../../styles.scss', './login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {

  loginForm: FormGroup;
  loading: boolean;
  username: AbstractControl;
  password: AbstractControl;
  rememberMe: AbstractControl;
  error: boolean;
  private loginSub: Subscription;
  showPage = false;

  constructor(private fb: FormBuilder,
              private authService: AuthService,
              private router: Router,
              private titleService: Title) {
    this.loginForm = this.fb.group({
      username: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
      rememberMe: ['']
    });
    this.username = this.loginForm.controls.username;
    this.password = this.loginForm.controls.password;
    this.rememberMe = this.loginForm.controls.rememberMe;
    this.loading = false;
    this.error = false;
  }

  login(): void {
    if (!this.username || !this.password) {
      return;
    }
    this.error = false;
    this.loading = true;
    this.loginSub = this.authService.login(this.username.value as string, this.password.value as string, this.rememberMe.value as boolean)
      .subscribe(
        (val) => {
          if (val !== null) {
            this.loading = false;
            if (val.success) {
              this.router.navigateByUrl('/');
            } else {
              this.error = true;
            }
          }
        }
      );
  }

  ngOnInit(): void {
    this.showPage = false;
    if (this.authService.isAuthenticated.getValue() === true) {
      this.router.navigateByUrl('/');
    } else {
      this.showPage = true;
    }
    this.titleService.setTitle('Filings Summary - Login Page');
  }

  ngOnDestroy(): void {
    if (this.loginSub) {
      this.loginSub.unsubscribe();
    }
  }

}
